import { render, staticRenderFns } from "./FirmBranchUserAssignment.vue?vue&type=template&id=bf2f3344"
import script from "./FirmBranchUserAssignment.vue?vue&type=script&lang=js"
export * from "./FirmBranchUserAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports